import {useGetAndSet} from "./useGetAndSet";
import {createSetFittersDataAction} from "../actions/dataActions";


export const useFittersData = (params, dataFresh) => {
    return useGetAndSet("fitters", params, createSetFittersDataAction, dataFresh)
}